import React, { useState, useEffect } from "react";
import CarCard, { Car } from "../CarCard/CarCard";
import FavoriteList from "../FavoriteList/FavoriteList";
import CarExtractor from "../CarExtractor/CarExtractor";
import ShareButton from "../ShareButton/ShareButton";
import CAR_IMAGE_DISCLAIMER from "../../constants/carImageDisclaimer";
import "./CarList.css";

interface Props {
  cars: Car[];
}

type SortOption =
  | "price-desc"
  | "price-asc"
  | "mileage-desc"
  | "mileage-asc"
  | "make";

// type FilterOption = "all-cars" | "only-fiesta" | "only-500" | "only-208";

type CarViews = "list" | "favorites";

const CarList: React.FC<Props> = ({ cars }) => {
  const [showCarIds, setShowCarIds] = useState(false);
  const [carView, setCarView] = useState<CarViews>("list");
  const [isReorderingFavorites, setIsReorderingFavorites] = useState(false);
  // const [sortBy, setSortBy] = useState<SortOption>("make");
  // const [filterBy, setFilterBy] = useState<FilterOption>("all-cars");
  const [favorites, setFavorites] = useState<number[]>(() => {
    return JSON.parse(localStorage.getItem("favorites") || "[]");
  });

  const allMakes = ["Ford", "Kia", "Peugeot", "SEAT"];
  const [selectedMakes, setSelectedMakes] = useState<string[]>(["All"]);

  useEffect(() => {
    const url = new URL(window.location.href);
    const showIdParam = url.searchParams.get("carid");

    if (showIdParam) {
      setShowCarIds(true);
    }
  }, [setShowCarIds]);

  // const sortedCars = (cars: Car[]) => {
  //   return [...cars].sort((a, b) => {
  //     switch (sortBy) {
  //       case "price-desc":
  //         return b.cost - a.cost;
  //       case "price-asc":
  //         return a.cost - b.cost;
  //       case "mileage-desc":
  //         if (a.mileage === null) return b.mileage === null ? 0 : 1;
  //         if (b.mileage === null) return -1;
  //         return b.mileage - a.mileage;
  //       case "mileage-asc":
  //         if (a.mileage === null) return b.mileage === null ? 0 : 1;
  //         if (b.mileage === null) return -1;
  //         return a.mileage - b.mileage;
  //       case "make":
  //         // return a.make.localeCompare(b.make);
  //         const nameA = `${a.make} ${a.model} ${a.trim}`.toLowerCase();
  //         const nameB = `${b.make} ${b.model} ${b.trim}`.toLowerCase();
  //         return nameA.localeCompare(nameB);
  //       default:
  //         return 0;
  //     }
  //   });
  // };

  const handleToggle = (make: string) => {
    setSelectedMakes((currentMakes) => {
      if (make === "All") return ["All"];

      const selectedWithoutAll = currentMakes.filter(
        (selectedMake) => selectedMake !== "All"
      );
      const updatedMakes = selectedWithoutAll.includes(make)
        ? selectedWithoutAll.filter((selectedMake) => selectedMake !== make)
        : [...selectedWithoutAll, make];

      return updatedMakes.length === 0 ||
        allMakes.every((availableMake) => updatedMakes.includes(availableMake))
        ? ["All"]
        : updatedMakes;
    });
  };

  const getFavoriteCount = (): number => {
    // const favorites = JSON.parse(localStorage.getItem("favorites") || "{}");
    return Object.keys(favorites).length;
  };

  const getButtonClassName = (): string => {
    return favorites.length > 0 ? "is-success has-text-dark" : "has-text-grey";
  };

  const isButtonDisabled = (): boolean => favorites.length === 0;

  const title = carView === "list" ? "Car Listings" : "Favourite Cars";

  // const allowedMakes = () => {
  //   if(selectedMakes === ) {
  //     case "All":
  //       return ["ford", "fiat", "peugeot"];

  //     case "Ford":
  //       return ["ford"];

  //     case "Fiat":
  //       return ["fiat"];

  //     case "Peugeot":
  //       return ["peugeot"];

  //     default:
  //       return [];
  //   }
  // };

  const filteredCars = cars.filter((car) =>
    selectedMakes.includes("All")
      ? allMakes.includes(car.make)
      : selectedMakes.includes(car.make)
  );

  return (
    <div>
      <CarExtractor favorites={favorites} setFavorites={setFavorites} />
      <h1 className="title is-3">{title}</h1>
      {/*
      <div className="sort-controls">
        <div className="field is-grouped">
          <label className="label">Sort by</label>
          <div className="control">
            <div className="select">
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value as SortOption)}
              >
                <option value="price-desc">Price (high to low)</option>
                <option value="price-asc">Price (low to high)</option>
                <option value="mileage-desc">Mileage (high to low)</option>
                <option value="mileage-asc">Mileage (low to high)</option>
                <option value="make">Make (A–Z)</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      */}

      <div className="field is-grouped is-grouped-right">
        <label className="label">Filter by Make</label>

        <div className="control">
          <label className="switch is-rounded">
            <input
              type="checkbox"
              checked={selectedMakes.includes("All")}
              onChange={() => handleToggle("All")}
            />
            <span className="check"></span>
            <span className="control-label">All</span>
          </label>
        </div>

        {allMakes.map((make) => (
          <div className="control" key={make}>
            <label className="switch is-rounded">
              <input
                type="checkbox"
                checked={selectedMakes.includes(make)}
                onChange={() => handleToggle(make)}
              />
              <span className="check"></span>
              <span className="control-label">{make}</span>
            </label>
          </div>
        ))}
      </div>

      {/* <div className="sort-controls">
        <div className="field is-grouped">
          <label className="label">Filter</label>
          <div className="control">
            <div className="select">
              <select
                value={filterBy}
                onChange={(e) => setFilterBy(e.target.value as FilterOption)}
              >
                <option value="all-cars">Show all cars</option>
                <option value="only-fiesta">Only Fiesta</option>
                <option value="only-500">Only Fiat 500</option>
                <option value="only-208">Only Peugeot 208</option>
              </select>
            </div>
          </div>
        </div>
      </div> */}

      <div className="mb-5">
        <div className="is-flex is-align-items-center is-flex-wrap-wrap" style={{ gap: "0.5rem" }}>
          {favorites.length > 0 && (
            <span className="mr-4">
              <ShareButton favorites={favorites} />
            </span>
          )}
          {carView === "list" && (
            <>
              <button
                className={`button   ${getButtonClassName()}`}
                disabled={isButtonDisabled()}
                onClick={() => {
                  setCarView("favorites");
                }}
              >
                <span className="icon is-small">
                  <i
                    className="fas fa-heart"
                    style={{
                      color: getFavoriteCount() > 0 ? "red" : "#CCCCCC",
                      fontSize: "1.2rem",
                      transition: "color 0.3s ease",
                    }}
                    title={"Favourite icon"}
                  ></i>
                </span>
                <span>&nbsp; Show Favourites</span>
              </button>
              <span className="fav-total">
                &nbsp; {getFavoriteCount()} cars selected (max 5).
              </span>
            </>
          )}
          {carView === "favorites" && (
            <>
              {!isReorderingFavorites && (
                <button
                  className="button is-warning"
                  type="button"
                  onClick={() => setIsReorderingFavorites(true)}
                >
                  Reorder list
                </button>
              )}
              <button
                className="button is-warning"
                type="button"
                onClick={() => {
                  setIsReorderingFavorites(false);
                  setCarView("list");
                }}
              >
                Show Car List
              </button>
            </>
          )}
        </div>
      </div>
      {carView === "list" && (
        <>
          <p className="image-disclaimer">{CAR_IMAGE_DISCLAIMER}</p>
          <div className="columns is-multiline">
            {filteredCars.map((car) => (
              <CarCard
                key={`${car.make}-${car.id}`}
                car={car}
                favorites={favorites}
                setFavorites={setFavorites}
                showCarIds={showCarIds}
              />
            ))}
          </div>
        </>
      )}
      {carView === "favorites" && (
        <FavoriteList
          // allCars={sortedCars(filteredCars)}
          allCars={filteredCars}
          favorites={favorites}
          setFavorites={setFavorites}
          isReordering={isReorderingFavorites}
          onReorderingChange={setIsReorderingFavorites}
        />
      )}
    </div>
  );
};

export default CarList;
